module.exports = __webpack_public_path__ + "static/media/ico_back_med_black_default.d854d09c.svg";